/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Row,
  Card,
  Button,
  Col,
} from 'antd';

import {
  COLORS,
  Text,
  Title,
} from 'components';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import useQuery from 'hooks/useQuery';
import { useNavigate } from 'react-router';

const PagoFallido = () => {
  const navigation = useNavigate();

  const [loading, setLoading] = useState(false);
  const [folio] = useQuery(['response']);
  const onCancel = () => {
    navigation('/');
    setLoading(false);
  };
  const ErrorsEnum = Object.freeze({
    3003: 'FONDOS INSUFICIENTES',
    0o1: 'CONSULTE CON EL EMISOR DE TARJETAS',
    3001: 'TRANSACCIÓN NO PERMITIDA',
    2010: 'FALLÓ AUTENTICACIÓN 3D/SAFEKEY',
    3009: 'TARJETA PERDIDA, RECOGER',
    2009: 'CVV INVALIDO',
    3004: 'PROMOCIÓN NO SOPORTADA',
    3006: 'SOLICITUD NO PERMITIDA',
    3014: 'PROMOCIÓN NO PERMITIDA',
    3204: 'IMPORTE MUY PEQUEÑO PARA LA PROMOCION',
    107: 'LLAME AL EMISOR',
    122: 'CODIGO DE SEGURIDAD INCORRECTO',
    101: 'TARJETA EXPIRADA',
    100: 'DENEGADO',
    3000: 'ERROR NO SOPORTADO POR CYBERSOURCE',
    2000: 'ESPERANDO AUTENTICACIÓN',
    2001: 'TARJETA NO ENROLADA',
    109: 'COMERCIO INVALIDO',
    110: 'MONTO INVALIDO',
    181: 'ERROR DE FORMATO',
    183: 'CODIGO MONEDA NO VALIDO',
    187: 'DENEGAR - NUEVA TARJETA EMITIDA',
    189: 'COMERCIO CANCELADO O CERRADO',
    106: 'INTENTOS DE PIN EXCEDIDOS',
    111: 'CUENTA NO VALIDA O MIRC NO VALIDO',
    115: 'FUNCION SOLICITADA NO ADMITIDA',
    117: 'PIN NO VALIDO',
    119: 'TITULAR NO ENROLADO O NO PERMITIDO',
    125: 'FECHA VIGENCIA INVALIDA',
    200: 'RETIRAR TARJETA',
  });

  const CardRecibo = () => (
    <Card title={(
      <Title level={3}>
        PAGO EN LINEA
      </Title>
    )}
    >
      <CardHeader>
        <Row justify="center">
          <Title level={3}>
            El Pago no ha sido satisfactorio
            {' '}
            error:
            {' '}
            {folio}
            {' '}
            -
            {' '}
            {ErrorsEnum?.[folio] || `ERROR DESCONOCIDO ${folio}`}
            {' '}
            <LoadingOutlined spin={loading} />
          </Title>
        </Row>

      </CardHeader>
      <br />
      <br />
      <Row justify="center">
        <Col>
          <ExitButton
            disabled={loading}
            onClick={() => onCancel()}
          >
            <Text>Salir</Text>
            <CloseOutlined />
          </ExitButton>
        </Col>
      </Row>
      <br />
    </Card>
  );

  return (
    <CardRecibo />
  );
};

const CardHeader = styled.div`
  background-color:${COLORS.accent};
  padding: 15px 0;
  text-align: center;
  .ant-typography {
    color: #FFFFFF !important;
  }
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const ExitButton = styled(Button)`
  color: ${COLORS.gray};
  border-color: ${COLORS.gray};
  background-color: transparent;
  border-radius: 0.25rem;
`;
// const StyledCol = styled(Col)`
//   /* border-bottom-size: 1px; */
//   border-bottom-style: solid;
//   border-bottom-color: #f8f9fa;
// `;

//   display: inline-block;
//   font-weight: 400;
//   line-height: 1.5;
//   vertical-align: middle;
//   user-select: none;
//   padding: 0.375rem 0.75rem;
//   font-size: 1rem;
//   border-radius: 0.25rem;
//   transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
//     border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
//   font-family: inherit;
//   width: 100%;
//   max-width: 500px;
// `;

export default PagoFallido;
